import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[appFadeSlideInOnce]',
  standalone: false
})
export class FadeSlideInOnceDirective implements OnInit {
  @Input('appFadeSlideInOnce') animationKey = '';

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    const alreadyShown = sessionStorage.getItem(this.animationKey);

    if (!alreadyShown) {
      sessionStorage.setItem(this.animationKey, 'true');

      const el = this.el.nativeElement;

      this.renderer.setStyle(el, 'position', 'relative');
      this.renderer.setStyle(el, 'opacity', '0');
      this.renderer.setStyle(el, 'transform', 'translateY(-40px)');
      this.renderer.setStyle(el, 'transition', 'opacity 1s ease-out, transform 1s ease-out');
      this.renderer.setStyle(el, 'will-change', 'opacity, transform');

      requestAnimationFrame(() => {
        this.renderer.setStyle(el, 'opacity', '1');
        this.renderer.setStyle(el, 'transform', 'translateY(0)');
      });
    }
  }
}